/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.string().uuid(),
  createdAt: z.number(),
  updatedAt: z.number(),
  construction_id: z.string().uuid(),
  material_qr_id: z.number(),
  stir_batch_id: z.string().uuid().nullable(),
  process_execution_id: z.string().uuid().nullable(),
  used_ratio: z.number(),
  deleted_at: z.number().nullable(),
});
const create = base.extend({
  process_execution_id: base.shape.process_execution_id.optional(),
  used_ratio: base.shape.used_ratio.optional(),
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
})
.extend({ id: z.string().uuid() })
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const ConstructionMaterialConsumptionBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type ConstructionMaterialConsumptionBase = z.infer<typeof base>;
export type ConstructionMaterialConsumptionBasePutPayload = z.infer<typeof put>;
export type ConstructionMaterialConsumptionBasePatchPayload = z.infer<typeof patch>;
export type ConstructionMaterialConsumptionBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type ConstructionMaterialConsumptionBaseCreateAttributes = z.infer<typeof create>;
export type ConstructionMaterialConsumptionBaseUpdateAttributes = z.infer<typeof update>;
export type ConstructionMaterialConsumptionBaseCacheAttributes = z.infer<typeof cache>;
export type ConstructionMaterialConsumptionBaseCachesAttributes = z.infer<typeof caches>;